import { render, staticRenderFns } from "./suppliers.vue?vue&type=template&id=4bcb075f&scoped=true&"
import script from "./suppliers.vue?vue&type=script&lang=js&"
export * from "./suppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb075f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bcb075f')) {
      api.createRecord('4bcb075f', component.options)
    } else {
      api.reload('4bcb075f', component.options)
    }
    module.hot.accept("./suppliers.vue?vue&type=template&id=4bcb075f&scoped=true&", function () {
      api.rerender('4bcb075f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/suppliers.vue"
export default component.exports